<div class="banner card {{ customClass }}" [ngClass]="{
bci_banner: translationKeyPrefix === 'bci_banner',
adv_trading_banner: translationKeyPrefix === 'adv_trading_banner'
}">
	<div class="banner-icon">
		<img [src]="iconSrc" alt="Logo" />
	</div>
	<div class="banner-text">
		<h3 class="banner-headline">{{ translationKeyPrefix ? (translationKeyPrefix + "_title" | translate: translationValues.headline) : bannerTitle }}</h3>
		<p class="banner-description">
			{{ translationKeyPrefix ? (translationKeyPrefix + "_description" | translate: translationValues.description) : bannerDescription }}
		</p>
	</div>
	<div class="banner-action">
		<button
			class="btn btn-white"
			[ngClass]="{
				'btn-inverse': actionBtnType === 'inverse'
			}"
			(click)="actionClicked.emit()">
			{{ translationKeyPrefix ? (translationKeyPrefix + "_button" | translate: translationValues.action) : bannerButtonText }}
		</button>
	</div>
	<div class="banner-dismiss">
		<button type="button" class="close-button" (click)="dismissClicked.emit()">
			<span class="bpi__icon-close"></span>
		</button>
	</div>
</div>
